import { KeyValue } from '../../common/redux/api/web-api'

export function isConfigReadonly(key: string, configKeys?: KeyValue[] | undefined | null): boolean {
    const config = configKeys?.find((x) => x.key === key)
    if (!config || config.readonly) {
        return true
    }

    return false
}
